import { Hub } from "aws-amplify/utils";
import store from "@/store";
import { clearAppAuthState, resetAuthBootstrap } from "@/services/authSession.js";

/**
 * Listen for Amplify auth lifecycle events.
 * signedOut clears Vuex; tokenRefresh_failure is logged only (no redirect).
 */
export function registerAuthHubListener() {
  Hub.listen("auth", ({ payload }) => {
    const { event, data } = payload || {};

    if (event === "signedOut") {
      console.warn("[auth] hub_signedOut");
      clearAppAuthState(store);
      resetAuthBootstrap();
      return;
    }

    if (event === "tokenRefresh_failure") {
      const err = data?.error;
      console.warn("[auth] hub_tokenRefresh_failure", {
        name: err?.name,
        message: err?.message,
      });
    }
  });
}
